import { createSlice } from "@reduxjs/toolkit";
import { LanguagesResponse } from "../../server/types/index.js";
import { Language } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "languages";

const initialState: Language[] = [];

export const getLanguages = createAppAsyncThunk(
  `${sliceName}/getLanguages`,
  (_: void, { dispatch }) =>
    fetch({ dispatch, authorize: false })
      .get("languages")
      .json<LanguagesResponse>()
      .then((res) => res.languages),
);

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLanguages.fulfilled, (_state, { payload }) => payload);
  },
});

export default slice.reducer;
